import React, { useState, useEffect, useRef } from "react";

const fieldLabels = {
  basiceducation: "Basic Education",
  professionaleducational: "Professional Education",
  specialization: "Specialization",
  // otherspecializatio: "Other Specialization",
  curerntstatus: "Current Status",
  occupation: "Occupation",
};

const Steps4 = ({
  count,
  setCount,
  detailsSet,
  details,
  initialData,
  completeCurrentStep,
}) => {
  const [currentStatus, setCurrentStatus] = useState("");
  const [formData, setFormData] = useState();
  const [errors, setErrors] = useState();

  useEffect(() => {
    setFormData(details);
  }, [details]);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value = "" } = e.target;
    if (!!name) {
      setFormData({ ...formData, [name]: value });
    }
  };

  const transformData = (data) => {
    return {
      education: {
        basiceducation: data.basiceducation || "",
        professionaleducational: data.professionaleducational || "",
        specialization: data.specialization || "",
        // otherspecializatio: data.otherspecializatio || "",
        curerntstatus: data.curerntstatus || "",
        occupation: data.occupation || "",
      },
    };
  };

  const handleSubmit = (e) => {
    try {
      e.preventDefault();

      const newErrors = {};
      Object.keys(fieldLabels).forEach((field) => {
        if (!formData?.[field]) {
          newErrors[field] = `Please enter ${fieldLabels[field]}`;
        }
      });

      console.log("Error", newErrors);
      setErrors(newErrors);

      if (Object.keys(newErrors).length > 0) return;

      const formattedData = transformData(formData);
      console.log("Transformed Data:", formattedData);
      // Proceed with the next step or any other logic
      detailsSet(formData); // Assuming this sets form data in a parent state
      setCount(count + 1); // Assuming this moves to the next step
      // completeCurrentStep(count);
    } catch (error) {
      console.error("Error in handleSubmit:", error);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {/* <div className="stepProgrees text-start mt-2">
        <p className="d-flex tittle-text mb-0">
          <b style={{ color: "#034DA2" }} className="">
          Education/Occupation
          </b>
        </p>
        <p style={{ color: "#034DA2" }} className="tittle-text mb-0">
        Education Occupation Info
        </p>
      </div> */}
      <div className="mt-4 main p-4 border rounded-4  bg-white">
        <div className="row ">
          <div className="col-lg-2">
            <label className="tittle-text" htmlFor="education">
              Basic Education
            </label>
            <select
              name="basiceducation"
              value={formData?.basiceducation || ""}
              onChange={handleInputChange}
              className="form-select mt-2"
              aria-label="Default select example"
            >
              <option value="">Select Title</option>
              {/* Map through details.title */}

              {initialData?.basiceducation?.map((title, index) => (
                <option key={index} value={title?.list_value}>
                  {title?.list_label}
                </option>
              )) || <option>Loading...</option>}
            </select>
            {errors?.basiceducation && (
              <div className="invalid-feedback">{errors.basiceducation}</div>
            )}
          </div>

          <div className="col-lg-5">
            <label className="tittle-text" htmlFor="Professional Education">
              {" "}
              Professional Education
            </label>
            <select
              name="professionaleducational"
              value={formData?.professionaleducational || ""}
              onChange={handleInputChange}
              className="form-select mt-2"
              aria-label="Default select example"
            >
              <option value="">Select Title</option>
              {/* Map through details.title */}

              {initialData?.profeducation?.map((title, index) => (
                <option key={index} value={title?.list_value}>
                  {title?.list_label}
                </option>
              )) || <option>Loading...</option>}
            </select>
          </div>
          <div className="col-lg-5">
            <label className="tittle-text" htmlFor="name">
              Specialization
            </label>
            <select
              name="specialization"
              value={formData?.specialization || ""}
              onChange={handleInputChange}
              className="form-select mt-2"
              aria-label="Default select example"
            >
              {" "}
              <option value="">Select Title</option>
              {initialData?.specialisation?.map((title, index) => (
                <option key={index} value={title?.list_value}>
                  {title?.list_label}
                </option>
              )) || <option>Loading...</option>}
            </select>
          </div>

          {/* current Status  */}

          <div className="col-11 mt-3">
            <label className="form-label tittle-text fw-semibold">
              Current Status
            </label>
            <div className="d-flex gap-3 flex-wrap">
              {["Student", "Service", "Business", "Retired", "Honorary"].map(
                (status, index) => (
                  <React.Fragment key={index}>
                    <input
                      hidden
                      type="radio"
                      name="curerntstatus"
                      value={status}
                      id={`curerntstatus-${index}`}
                      onChange={handleInputChange}
                      key={index}
                    />
                    <label
                      htmlFor={`curerntstatus-${index}`}
                      className={`btn rounded-5 button1 ${
                        // currentStatus === status ? "active" : ""
                        formData?.curerntstatus === status ? "active" : ""
                      }`}
                    >
                      {status}
                    </label>
                  </React.Fragment>
                )
              )}
            </div>
            {errors?.curerntstatus && (
              <div className="text-danger small">{errors.curerntstatus}</div>
            )}
          </div>

          <div className="col-11 mt-3">
            <div className="col-lg-2 col-md-6 ">
              <label className="tittle-text" htmlFor="">
                Occupation
              </label>
              <select
                name="occupation"
                className="form-select mt-2"
                aria-label="Default select example"
                value={formData?.occupation || ""}
                onChange={handleInputChange}
              >
                <option className="inputText" value="">
                  Select...
                </option>
                {initialData?.occupation?.map((title, index) => (
                  <option key={index} value={title?.list_value}>
                    {title?.list_label}
                  </option>
                )) || <option>Loading...</option>}
              </select>
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-end gap-3 mt-3">
        {count !== 0 && (
          <button
            type="button"
            className="rounded-5 btnBlue"
            onClick={() => setCount(count - 1)}
          >
            Previous
          </button>
        )}

        <button type="submit" className="rounded-5 btnBlue">
          Next
        </button>
      </div>
    </form>
  );
};

export default Steps4;
